import { render, staticRenderFns } from "./DsMainLayout.vue?vue&type=template&id=8806c5d8&"
import script from "./DsMainLayout.vue?vue&type=script&lang=js&"
export * from "./DsMainLayout.vue?vue&type=script&lang=js&"
import style0 from "./DsMainLayout.vue?vue&type=style&index=0&id=8806c5d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports